// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css
import Vue from 'vue'
import App from './App'
import router from './router/router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import store from './store/index'
import Vuex from 'vuex'
import Ue from './components/SearchBar/index';
import NormailizeCss from 'normalize.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueResource from 'vue-resource'
import AxiosPlugin from './router/http'

import './permission'
import './icons' // icon
import i18n from './api/lang'
import CommonUtils from "./lib/CommonUtils";

//全局过滤器
import * as filters from './filters' // global filters

import Transfer  from './vendor/element/transfer' // global filters

Vue.use(AxiosPlugin);//拦截器
Vue.use(VueResource);
Vue.use(Ue);
Vue.use(Vuex);
Vue.prototype.$CommonUtils=CommonUtils;
Vue.component("el-transfer", Transfer);
Vue.component('icon', Icon);

/* eslint-disable no-new */

Vue.use(ElementUI, {
  // size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});


let data = JSON.parse(window.sessionStorage.getItem('user'));
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});


new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js